var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ErrorIcon from "./Icons/ErrorIcon";
import { Button } from "@opala-ds/react";
import { useErrorFeedbackStore } from "../stores/errorFeedbackStore";
export default function ErrorFeedback() {
    var openModal = useErrorFeedbackStore(function (state) { return state.open; });
    var setOpen = useErrorFeedbackStore(function (state) { return state.setOpen; });
    var description = useErrorFeedbackStore(function (state) { return state.description; });
    return (_jsx(_Fragment, { children: openModal && (_jsxs(_Fragment, { children: [_jsx("div", { className: "fixed inset-0 bg-black bg-opacity-50 z-40" }), _jsx("dialog", __assign({ open: true, className: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-transparent" }, { children: _jsxs("div", __assign({ className: "w-full max-w-md bg-white rounded-lg p-6 flex flex-col items-center shadow-lg" }, { children: [_jsx(ErrorIcon, {}), _jsx("span", __assign({ className: "text-base font-semibold text-[#262626] leading-none mt-6" }, { children: "Algo deu errado na sua inscri\u00E7\u00E3o!" })), _jsx("p", __assign({ className: "text-base text-center md:font-bold text-[#262626] mt-10 mb-12" }, { children: description })), _jsx(Button, __assign({ className: "px-16 min-w-[290px]", type: "button", onClick: function () { return setOpen(false); } }, { children: "Ok, Entendi!" }))] })) }))] })) }));
}
